import { createContainer } from "unstated-next"
import * as voicifyApi from '../api';
import InvalidResult from "../models/result/InvalidResult";
import { useState } from "react";
import IResult from "../models/result/IResult";
import TopIntents from "../models/customAssistant/TopIntents";
import CallStatistics from "../models/customAssistant/CallStatistics";

function useOrgAnalyticsContainer() {
    const [error, setError] = useState("");
    const [loadingTopIntents, setLoadingTopIntents] = useState(false);
    const [loadingCallStatistics, setLoadingCallStatistics] = useState(false);

    const getOrgLevelCallStatistics = async (organizationId: string, startDate: string, endDate: string): Promise<IResult<CallStatistics>> => {
        setLoadingCallStatistics(true);
        const result = await voicifyApi.getCallStatistics(organizationId, startDate, endDate);
        setLoadingCallStatistics(false);
        if (result.resultType === "Ok") {
            return {
                data: result.data,
                resultType: "Ok",
                errors: null
            }
        }
        else {
            setError(result.errors?.[0]);
            return new InvalidResult<CallStatistics>(result.errors?.[0]);
        }
    }

    const getOrgLevelTopIntents = async (organizationId: string, startDate: string, endDate: string): Promise<IResult<TopIntents[]>> => {
        setLoadingTopIntents(true);
        const result = await voicifyApi.getTopIntents(organizationId, startDate, endDate);
        setLoadingTopIntents(false);
        if (result.resultType === "Ok") {
            return {
                data: result.data,
                resultType: "Ok",
                errors: null
            }
        }
        else {
            setError(result.errors?.[0]);
            return new InvalidResult<TopIntents[]>(result.errors?.[0]);
        }
    }

    return {
        getOrgLevelCallStatistics,
        getOrgLevelTopIntents,
        error,
        loadingTopIntents,
        loadingCallStatistics
    };

}
const OrgAnalyticsContainer = createContainer(useOrgAnalyticsContainer);
export default OrgAnalyticsContainer;
